import React from "react";
import BotAvatar from "./BotAvatar";

const RenderHTMLWidget = ({ payload }) => {
    return (
        <>
            <div className="react-chatbot-kit-chat-bot-message-container">
                <BotAvatar />
                <div className="react-chatbot-kit-chat-bot-message" dangerouslySetInnerHTML={{ __html: payload }} />
            </div>
        </>
    );
};
export default RenderHTMLWidget;
